
		import PageState from "./state"
		import mutations from "./mutations"
		import {getModule} from '@/store/store'
		let APIS = {
			//获取优惠券列表
            getCouponList:`/apis/moyin-account/v1/coupon/list/homepage`,
		}
		export default {
			...getModule({
				state:new PageState(),
				mutations,
				actions:{},
				APIS,
				name:"couponListPage"
			})
		}